<template>
  <div class="py-2">
    <bundle-request-modal
      @close="show_request_modal = false"
      @request_created="request_created"
      ref="request_modal"
    />
    <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
      {{ $t("participa en el bundle") }}
    </h3>
    <div
      class="ui equal width grid pbundle pbundle"
      v-for="(bundle, index) in bundles"
      :key="index"
    >
      <div class="column">
        <p class="cgray">{{ bundle.setup.name }}</p>
      </div>
      <div class="column">
        <div
          @click="request(bundle)"
          class="ui button modal-button-green is-uppercase"
          v-bind:class="{ disabled: bundle.nvb_bundle_request }"
        >
          {{ $t("participar") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BundleRequestModal from "./BundleRequestModal.vue";
import { local_api, error_toast, success_toast } from "@/utils";

export default {
  name: "NvidiaTicketStoreBundleRequest",
  components: { BundleRequestModal },
  data() {
    return {
      show_request_modal: false,
      stores: [],
      bundles: [],
    };
  },
  methods: {
    setStores(stores) {
      let vm = this;
      vm.stores = stores;
      console.log("Setting stroes");
      vm.$refs.request_modal.setStores(stores);
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/nworkforce/store/do-get-new-bundle-list", {})
        .then(function(r) {
          vm.bundles = r.bundles;
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
    request(bundle) {
      let vm = this;
      // vm.show_request_modal = true;
      // vm.$refs.request_modal.setBundle(bundle);
      vm.$refs.request_modal.setBundle(bundle);
      vm.$refs.request_modal.show();
    },
    request_created(/* request */) {
      this.show_request_modal = false;
      success_toast(this.$t("request created"));
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
